let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d3blt")).then(() => parcelRequire('5Abiq'));